import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageBlockView } from './ImageBlockView';

export const ImageBlock = Image.extend({
  addAttributes() {
    const parent = this.parent?.() ?? {};
    return {
      ...parent,
      width: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('width'),
        renderHTML: (attributes: Record<string, any>) =>
          attributes.width ? { width: attributes.width } : {},
      },
      height: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('height'),
        renderHTML: (attributes: Record<string, any>) =>
          attributes.height ? { height: attributes.height } : {},
      },
      align: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-align'),
        renderHTML: (attributes: Record<string, any>) =>
          attributes.align ? { 'data-align': attributes.align } : {},
      },
      float: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-float'),
        renderHTML: (attributes: Record<string, any>) =>
          attributes.float ? { 'data-float': attributes.float } : {},
      },
      posX: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const v = element.getAttribute('data-pos-x');
          return v != null ? parseFloat(v) : null;
        },
        renderHTML: (attributes: Record<string, any>) =>
          attributes.posX != null ? { 'data-pos-x': String(attributes.posX) } : {},
      },
      posY: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const v = element.getAttribute('data-pos-y');
          return v != null ? parseFloat(v) : null;
        },
        renderHTML: (attributes: Record<string, any>) =>
          attributes.posY != null ? { 'data-pos-y': String(attributes.posY) } : {},
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageBlockView);
  },
});
